import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config/serverApiConfig";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import styles from "./addCompanyStyles.module.css";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

function CompanyAddCompany() {
  // State Hooks
  const [companyName, setCompanyName] = useState("");
  const [adminFirstName, setAdminFirstName] = useState("");
  const [adminLastName, setAdminLastName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  // Removed adminSiteUrl field
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Modal state for success message
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();
  const adminType = "2";

  // Email Validation
  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  };

  // Handle File Change for Company Logo Upload
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Validate file size (1MB limit)
    if (selectedFile.size > 1024 * 1024) {
      setFormErrors((prev) => ({
        ...prev,
        imageFile: "Image size should be less than 1MB",
      }));
      return;
    }

    setImageFile(selectedFile.name);

    // Display a preview of the selected image
    const reader = new FileReader();
    reader.onload = (event) => {
      setImageUrl(event.target.result);
    };
    reader.readAsDataURL(selectedFile);

    // Upload the image to the server
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        "https://starbehaviors.com/uploadimage.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Image uploaded successfully", response.data);
    } catch (error) {
      console.error("Image upload failed", error);
      setFormErrors((prev) => ({
        ...prev,
        imageFile: "Image upload failed",
      }));
    }
  };

  // Validate Form
  const validateForm = () => {
    const errors = {};

    if (!companyName.trim())
      errors.companyName = "Company Name is required";
    if (!adminFirstName.trim())
      errors.adminFirstName = "First Name is required";
    if (!adminLastName.trim())
      errors.adminLastName = "Last Name is required";
    if (!contactPhone.trim())
      errors.contactPhone = "Contact Phone is required";
    if (!adminEmail.trim())
      errors.adminEmail = "Email is required";
    else if (!isValidEmail(adminEmail))
      errors.adminEmail = "Invalid email format";
    if (!adminPassword.trim())
      errors.adminPassword = "Password is required";
    if (!imageFile)
      errors.imageFile = "Image is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Clear Form (not used after saving per requirements)
  const clearForm = () => {
    setCompanyName("");
    setAdminFirstName("");
    setAdminLastName("");
    setContactPhone("");
    setAdminEmail("");
    setAdminPassword("");
    setImageFile(null);
    setImageUrl(null);
    setFormErrors({});
    setErrorMessage("");
    setSuccessMessage("");
  };

  // Handle Save
  const handleSave = async () => {
    if (!validateForm()) return;

    // Build payload; fields not filled are sent as empty strings
    const dataToSend = {
      companyName,
      adminid: "",
      adminemail: adminEmail,
      admin_first_name: adminFirstName,
      admin_last_name: adminLastName,
      contactPhone,
      admin_type: adminType,
      admin_password: adminPassword,
      imageFile: imageFile || "",
      admin_site_url: "", // Set to empty as per requirements
      adminemails: "",
      adminpageheader: "",
      adminpagecontent: "",
      adminemailadminpageoffers: "",
      adminpagecta: "",
      assessmentRecipient: ""
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/sb_addeditcompanyuser`,
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Server Response:", response.data);

      if (
        response.data.Message === "User with the following email address already exists"
      ) {
        setErrorMessage("Company with this email address already exists.");
        setSuccessMessage("");
      } else if (response.data.Message === "User Login User type: 2") {
        setSuccessMessage("Company added successfully");
        setErrorMessage("");
        // Show the success modal
        setShowModal(true);
      } else {
        setErrorMessage("Unexpected response: " + response.data.Message);
        setSuccessMessage("");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("An error occurred while saving the form.");
      setSuccessMessage("");
    }
  };

  // Modal effect: When the modal is shown, automatically navigate after a delay
  useEffect(() => {
    let timer;
    if (showModal) {
      timer = setTimeout(() => {
        navigate("/company-login");
      }, 1500);
    }
    return () => clearTimeout(timer);
  }, [showModal, navigate]);

  return (
    <>
     <div style={{ background: '#fff', paddingLeft: '35px', paddingTop: '15px', color: '#0088FF' }}>
        <a onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}><MdOutlineKeyboardArrowLeft size={20} /> Back</a>
      </div>
      <div className={styles.formContainer}>
        <h2>Add New Company</h2>
        {/* Success or error messages */}
        {successMessage && (
          <div className={styles.successMessage}>{successMessage}</div>
        )}
        

        <form className={styles.assignForm}>
          <div className={styles.formRow}>
            <label>Company Name*</label>
            <input
              type="text"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              className={
                formErrors.companyName ? styles.errorInput : styles.selectField
              }
            />
            {formErrors.companyName && (
              <div className={styles.errorMessage}>
                {formErrors.companyName}
              </div>
            )}
          </div>

          <div className={styles.formRow}>
            <label>First Name*</label>
            <input
              type="text"
              value={adminFirstName}
              onChange={(e) => setAdminFirstName(e.target.value)}
              className={
                formErrors.adminFirstName ? styles.errorInput : styles.selectField
              }
            />
            {formErrors.adminFirstName && (
              <div className={styles.errorMessage}>
                {formErrors.adminFirstName}
              </div>
            )}
          </div>

          <div className={styles.formRow}>
            <label>Last Name*</label>
            <input
              type="text"
              value={adminLastName}
              onChange={(e) => setAdminLastName(e.target.value)}
              className={
                formErrors.adminLastName ? styles.errorInput : styles.selectField
              }
            />
            {formErrors.adminLastName && (
              <div className={styles.errorMessage}>
                {formErrors.adminLastName}
              </div>
            )}
          </div>

          <div className={styles.formRow}>
            <label>Contact Phone(111-222-3333)*</label>
            <input
              type="number"
              value={contactPhone}
              onChange={(e) => setContactPhone(e.target.value)}
              className={
                formErrors.contactPhone ? styles.errorInput : styles.selectField
              }
            />
            {formErrors.contactPhone && (
              <div className={styles.errorMessage}>
                {formErrors.contactPhone}
              </div>
            )}
          </div>

          <div className={styles.formRow}>
            <label>Email*</label>
            <input
              type="email"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
              className={
                formErrors.adminEmail ? styles.errorInput : styles.selectField
              }
            />
            {formErrors.adminEmail && (
              <div className={styles.errorMessage}>
                {formErrors.adminEmail}
              </div>
            )}
          </div>

          <div className={styles.formRow}>
            <label>Password*</label>
            <input
              type="password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              className={
                formErrors.adminPassword ? styles.errorInput : styles.selectField
              }
            />
            {formErrors.adminPassword && (
              <div className={styles.errorMessage}>
                {formErrors.adminPassword}
              </div>
            )}
          </div>

          {/* Company Logo File Upload */}
          <div className={styles.formRow}>
            <label>Company Logo*</label>
            <input
              type="file"
              onChange={handleFileChange}
              className={
                formErrors.imageFile ? styles.errorInput : styles.selectField
              }
            />
            {formErrors.imageFile && (
              <div className={styles.errorMessage}>
                {formErrors.imageFile}
              </div>
            )}
            {imageUrl && (
              <img
                src={imageUrl}
                alt="Company Logo"
                className={styles.logoPreview}
              />
            )}
          </div>
          {errorMessage && (
          <div className={styles.errorMessage}>{errorMessage}</div>
        )}
          <div className={styles.buttonContainer}>
            <button
              type="button"
              onClick={handleSave}
              className={styles.submitButton}
            >
              Save
            </button>
            <button
              type="button"
              onClick={clearForm}
              className={styles.submitButton}
              style={{ backgroundColor: "red" }}
            >
              Clear
            </button>
          </div>
        </form>
        

        {/* Success Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>Company created successfully</Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default CompanyAddCompany;
